export const PROCARD_CONSTANTS = {
  countryISOAlpha2Code: "NL",
} as const;

export const PROCARD_FORM_STEPS = [
  "consent",
  "company-details",
  "company-list",
  "authorized-person",
  "bank-details",
  "summary",
];

export type ProCardFormStep =
  | "consent"
  | "company-details"
  | "company-list"
  | "authorized-person"
  | "bank-details"
  | "summary";

export enum ProCardApplicationType {
  WITH_CREDIT = "PROCARD",
  WITHOUT_CREDIT = "PROCARD_ZERO",
}

const PROCARD_BANK_TYPES = ["Company", "Personal"] as const;

export type ProCardBankType = (typeof PROCARD_BANK_TYPES)[number];

export type ProCardFormData = {
  verify_age: boolean;
  terms_accepted: boolean;
  company_name: string;
  company_duns: string;
  company_address_line1: string;
  company_address_city: string;
  company_country: string;
  company_postcode: string;
  company_registration_number: string;
  account_holder_name: string;
  phone_number: string;
  [key: string]: any;
};

export type ProCardApplicationStatus =
  | "draft"
  | "active"
  | "processed"
  | "failed";

export const ProCardActiveStatuses = ["active" ,"processed"];

export const PROCARD_STATUS_LIST = [
  "ok",
  "pending",
  "failed",
  "cancel",
  "print",
] as const;

export type ProCardPostApplyStatus = (typeof PROCARD_STATUS_LIST)[number];
